import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';

import 'styles/placeholder.css';
import './productPlaceholder.styles.scss';

export default class ProductPlaceholder extends Component {
    render() {
        return (
            <Flex wrap w={1} className="product-placeholder" mb={2}>
                <Flex w={1} mb={1}>
                    <Box w={[112, 136]} className="placeholder__item product-placeholder--image">
                        <Box p={1} className="placeholder__animation"/>
                    </Box>
                    <Flex wrap auto>
                        <Box column w={2 / 3} className="placeholder product-placeholder--description" >
                            <Box w={1} mb={5} className="placeholder__item">
                                <Box p={1} className="placeholder__animation"/>
                            </Box>
                            <Box w={1} mb={5} className="placeholder__item">
                                <Box p={1} className="placeholder__animation" />
                            </Box>
                            <Box w={1} mb={5} className="placeholder__item">
                                <Box p={1} className="placeholder__animation" />
                            </Box>
                            <Box w={1} mb={5} className="placeholder__item">
                                <Box p={1} className="placeholder__animation" />
                            </Box>
                            <Box w={1} mb={5} className="placeholder__item">
                                <Box p={1} className="placeholder__animation" />
                            </Box>
                        </Box>
                        <Flex w={[2 / 3, 1 / 3]} justify={[null, 'flex-end']}>
                            <Box w={[1, 50]} className="placeholder__item product-placeholder--price">
                                <Box p={1} className="placeholder__animation" />
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>

                <Flex auto justify="flex-end" className="placeholder product-placeholder--controls">
                    <Flex w={[1, 1 / 2]}>
                        <Box w={1 / 8} className="placeholder__item">
                            <Box p={1} className="placeholder__animation" />
                        </Box>
                        <Box ml={1} w={2 / 8} className="placeholder__item">
                            <Box p={1} className="placeholder__animation" />
                        </Box>
                        <Box ml={1} w={5 / 8} className="placeholder__item">
                            <Box p={1} className="placeholder__animation" />
                        </Box>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}
